import BaseController from "confinus_ui/base_controller";

export default class SubmitPriceUpdateController extends BaseController {
  public static targets = ["requiresScheduled"];

  declare protected readonly requiresScheduledTarget: HTMLInputElement;

  public publishScheduled(evt: Event) {
    // Set form attribute to indicate we are scheduling
    this.requiresScheduledTarget.setAttribute("value", "true");
  }
}
